export default "__VITE_ASSET__DvFaI5lG__"